<template>
  <FormulateInput type="checkbox" v-bind="$attrs" v-model="model">
    <template #label>
      <label class="formulate-input-label" :class="`formulate-input-label--${labelPosition}`" @click="model = !model">
        <template v-for="(link, index) in label">
          {{ link.label }} <a v-if="link" :key="index" :href="link.link" target="_blank" class="formulate-input-link">{{ link.text }}</a>
        </template>
        <span v-if="trailingLabel">{{ trailingLabel }}</span>
        <span v-if="isRequired">*</span>
      </label>
    </template>
  </FormulateInput>
</template>

<script>
import { ref } from '@vue/composition-api';

export default {
  props: {
    label: {
      type: Array,
      default: () => [],
    },
    trailingLabel: {
      type: String,
      default: null,
    },
    labelPosition: {
      type: String,
      default: 'after',
    },
    checked: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, context) {
    return {
      model: ref(props.checked),
      isRequired: (context.attrs.validation ?? '').includes('accepted'),
    };
  },
};
</script>

<style lang="postcss" scoped>
/deep/ .formulate-input {
  &-label {
    @apply style-body-sm m-0 text-neutral-ultradark px-nano hover:cursor-pointer;
  }

  &-wrapper {
    @apply flex items-start;
  }

  &-link {
    @apply underline outline-none text-neutral-ultradark;
  }

  &-help {
    @apply style-overline text-neutral-medium -mt-quark mb-xxxs;
  }

  &-errors {
    @apply style-overline text-feedback-error-medium mt-nano m-0 p-0 list-none;
  }

  &-element {
    @apply flex mt-quark;
  }
}
.formulate-input::v-deep {
  @apply relative text-neutral-ultradark mb-xs;

  &[data-is-showing-errors='true'] {
    input {
      @apply border-feedback-error-medium border-y-hairline;
    }
  }

  input {
    @apply w-[1.25rem] h-[1.25rem] border-solid p-0 rounded-[5px] border-hairline border-neutral-semilight appearance-none bg-no-repeat bg-center checked:bg-brand-secondary-medium checked:border-brand-secondary-medium m-0;
    background-image: url('/img/web/checkbox-check.svg');
  }
}
</style>
